import { View } from "react-native";
import { Typography, useTheme } from "@mui/material";
import { AppLogo } from "../../components/AppLogo";

export const Bookings = () => {
	const theme = useTheme();

	return (
		<View
			style={{
				flex: 1,
				justifyContent: "center",
				alignItems: "center",
				paddingHorizontal: 24,
			}}
		>
			<AppLogo size={120} showText={false} />

			<Typography
				variant="h4"
				sx={{
					marginTop: 4,
					fontWeight: 800,
					letterSpacing: 0.5,
					textAlign: "center",
					color: theme.palette.text.primary,
				}}
			>
				Bookings Closed
			</Typography>

			<Typography
				variant="body1"
				sx={{
					marginTop: 2,
					maxWidth: 480,
					textAlign: "center",
					lineHeight: 1.6,
					color: theme.palette.text.secondary,
				}}
			>
				We're not taking new appointments at the moment. Thanks for the love
				and patience, fam — the chair needs a quick breather.
			</Typography>

			<Typography
				variant="body2"
				sx={{
					marginTop: 3,
					maxWidth: 480,
					textAlign: "center",
					fontStyle: "italic",
					color: theme.palette.text.secondary,
				}}
			>
				Keep an eye on our socials for the next drop of available slots.
				Fresh fades are coming back soon.
			</Typography>
		</View>
	);
};
